import { getDayTimeRange } from '../dates';

const getTimeRangeFromDateKey = (dateKey: number) => {
  const dateKeyString = String(dateKey);
  const year = Number(dateKeyString.slice(0, 4));
  const month = Number(dateKeyString.slice(4, 6)) - 1;
  const day = Number(dateKeyString.slice(6, 8));

  const date = new Date();
  date.setFullYear(year);
  date.setMonth(month);
  date.setDate(day);

  return getDayTimeRange(date.getTime());
};

export default getTimeRangeFromDateKey;
